import { render, staticRenderFns } from "./UserInfoEdit.vue?vue&type=template&id=04a62162&scoped=true&"
import script from "./UserInfoEdit.vue?vue&type=script&lang=ts&"
export * from "./UserInfoEdit.vue?vue&type=script&lang=ts&"
import style0 from "./UserInfoEdit.vue?vue&type=style&index=0&id=04a62162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a62162",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VForm,VRow})
